module.exports = __webpack_public_path__ + "static/media/cartIcon.39c44110.svg";